import React from 'react';

import IndexedSubSectionWrapper from "hoc/IndexedSubSectionWrapper";
import LeadGenFieldCreateButtonConnected from "components/composites/LeadGenFieldCreateButtonConnected";
import * as ResourceApi from "../../../../../api/resources";
import {createButtonSectionFactory} from "hoc/CreateButtonSection";
import {FBCommentQuestionToolTip} from 'components/break/tooltips/breaks-steps-section-tool-tips';

import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';

import Config from 'Config';

export default {
    name: "leadGen",
    subSection: true,
    resource: true,
    hideIfResourceIsNoU: true,

    fields: [
        {
            type: 'resourceJsx',
            name: 'reportLink',

            props: {
                jsx: (resource) => {
                    // console.log(`leadgen`, resource)
                    return (
                        <React.Fragment>
                            { resource && 
                                <a href={`${Config.BEAKER2_URL}#/leadgen/${resource.id}/show/`} target="_leadgen">Report on Beaker2 <i className="external alternate icon small"/></a> 
                            }
                        </React.Fragment>
                        
                    )
                }
            }
        },

        {
            type: 'contenteditable',
            name: 'headline',
            required: false,
            props: {
                labelKey: 'editbreak.steps.lead_gen.headline'
            }
        },
        {
            type: 'image',
            name: 'headerImageId',
            idFor: 'headerImage',
            required: false,
            props: {
                labelKey: 'editbreak.steps.lead_gen.image',
                imageType: 'leadGen'
            }
        },
        {
            type: 'contenteditable',
            name: 'introCopy',
            required: false,
            props: {
              labelKey: 'editbreak.steps.lead_gen.intro_copy',
              maxLength: 500,
              placeholderKey: 'editbreak.steps.lead_gen.intro_copy.placeholder',
              validationRules: [
                  {
                      type: 'MarkupTextLimit',
                      params: {
                          limit: 500
                      }
                  }
              ]
            }
        },
        {
            type: 'contenteditable',
            name: 'bodyCopy',
            required: false,
            props: {
              labelKey: 'editbreak.steps.lead_gen.body_copy',
              placeholderKey: 'editbreak.steps.lead_gen.body_copy.placeholder'
            }
        },
        {
            type: 'text',
            name: 'commentQuestion',
            showField: (proxy) => (proxy.currentBaseResource.showFBComments && proxy.currentBaseResource.sponsoredType !== 'sponsored' ),
            props: {
                labelKey: 'editbreak.steps.related_breaks.commentQuestion',
                helpContent: <FBCommentQuestionToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage id={'tooltips.break.breaks_steps.fbCommentQuestion'}/></IntlProvider>
            }
        },
        {
            name: 'fields',
            subSection: true,
            resource: true,
            collection: true,
            sectionWrapper: IndexedSubSectionWrapper,
            deletable: true,

            props: {
                headerKey: 'editbreak.steps.lead_gen.fields',
                getCustomSectionHeader: (field, sectionIndex) => {
                    // console.log(`field`, field)
                    if ((field.name == 'customText1') || (field.name == 'customText2') || (field.name == 'customText3')) {
                        if (field.displayTitle) {
                            if ((field.displayTitle.startsWith("Email") || field.displayTitle.startsWith("email"))) {
                                return "⚠️ " + field.name + " - " + field.displayTitle 
                            }
                        }
                    }
                    return field.name;

                },
            },

            sortable: true,
            sortableName: "leadGenFieldsOrder",
            toggleSortLabelKey: 'editbreak.steps.lead_gen.fields.reorder_toggle',
            resourceType: ResourceApi.Types.LeadGenField,

            footerContent: LeadGenFieldCreateButtonConnected,

            fields: [
                {
                    type: 'yesnoradio',
                    name: 'required',
                    required: (proxy) => (proxy.currentResource.name !== "address2"),
                    props: {
                      labelKey: 'editbreak.steps.lead_gen.field.required'
                    }
                },
                {
                  type: 'contenteditable',
                  name: 'displayTitle',
                  required: (proxy) => (proxy.currentResource.name === "customText1" ||
                                        proxy.currentResource.name === "customText2" ||
                                        proxy.currentResource.name === "customText3"),
                  props: {
                    labelKey: 'editbreak.steps.lead_gen.field.custom_label',
                    maxLength: 125,
                    validationRules: [
                        {
                            type: 'MarkupTextLimit',
                            params: {
                                limit: 125
                            }
                        }
                    ]
                  }
                }
            ]
        },
        {
            name: 'confirmations',
            subSection: true,
            resource: true,
            collection: true,
            sectionWrapper: IndexedSubSectionWrapper,
            deletable: true,
            canDelete: (formProxy) => {
            //   var leadGenForm = formProxy.parentCurrentResource;
            //   return leadGenForm.confirmations && leadGenForm.confirmations.length > 1;
              return true;
            },

            sortable: true,
            sortableName: "leadGenConfirmationsOrder",
            toggleSortLabelKey: 'editbreak.steps.lead_gen.confirmations.reorder_toggle',
            resourceType: ResourceApi.Types.LeadGenConfirmation,

            props: {
                headerKey: 'editbreak.steps.lead_gen.confirmations.header',
                getCustomSectionHeader: (confirmation, sectionIndex) => {
                  return  confirmation.name
                          && confirmation.name.trim() !== "" ? "Confirmation " + (sectionIndex + 1) + ": " + confirmation.name : null;
                }
            },

            footerContent: createButtonSectionFactory(ResourceApi.Types.LeadGenConfirmation),

            fields: [
              {
                name: 'name',
                type: 'text',
                required: true,
                props: {
                  labelKey: 'editbreak.steps.lead_gen.confirmations.name'
                }
              },
              {
                name: 'text',
                type: 'contenteditable',
                required: true,
                props: {
                  labelKey: 'editbreak.steps.lead_gen.confirmations.text'
                }
              },
              {
                name: 'required',
                type: 'yesnoradio',
                required: true,
                props: {
                  labelKey: 'editbreak.steps.lead_gen.confirmations.required'
                }
              },
              {
                name: 'precheck',
                type: 'yesnoradio',
                required: true,
                props: {
                  labelKey: 'editbreak.steps.lead_gen.confirmations.prechecked'
                }
              },
              {
                name: 'callbackUrl',
                type: 'text',
                required: false,
                props: {
                  labelKey: 'editbreak.steps.lead_gen.confirmations.callback_url'
                }
              }
            ]
        }, // end confirmations
        {
            type: 'hardcodedText',
            props: {
            heading: 'Email Alerts',
              text: 'You can configure lead gen to send email alerts when a certian number of submissions has occurred.',
            }
        },
        {
            name: 'alerts',
            subSection: true,
            resource: true,
            collection: true,
            sectionWrapper: IndexedSubSectionWrapper,
            deletable: true,
            canDelete: (formProxy) => {
              var leadGenForm = formProxy.parentCurrentResource;
              return leadGenForm.alerts && leadGenForm.alerts.length > 1;
            },

            sortable: false,
            sortableName: "leadGenAlertsOrder",
            toggleSortLabelKey: 'editbreak.steps.lead_gen.confirmations.reorder_toggle',
            resourceType: ResourceApi.Types.LeadGenConfirmation,

            props: {
                headerKey: 'editbreak.steps.lead_gen.confirmations.header',
                getCustomSectionHeader: (alert, sectionIndex) => {
                  return (alert.email && alert.threshold) ? alert.email + " @ " + alert.threshold : "not configured"
                }
            },

            footerContent: createButtonSectionFactory(ResourceApi.Types.LeadGenAlert),

            fields: [
              {
                name: 'email',
                type: 'text',
                required: true,
                props: {
                  labelKey: 'email address to send alert to'
                }
              },
              {
                name: 'threshold',
                type: 'number',
                required: true,
                props: {
                  labelKey: 'threshold'
                }
              },
              {
                name: 'subject',
                type: 'text',
                required: false,
                props: {
                  labelKey: 'email subject'
                }
              },
              {
                name: 'message',
                type: 'textarea',
                required: false,
                props: {
                  labelKey: 'email message'
                }
              }
            ]
        }, // end alerts
        {
          subSection: true,
          key: "leadGenRules",
          sectionWrapper: IndexedSubSectionWrapper,
          props: {
            'headerKey': 'editbreak.steps.lead_gen.rules.header'
          },
          fields: [
            {
                name: 'hasAddressValidation',
                type: 'yesnoradio',
                required: true,
                props: {
                  labelKey: 'Require Physical Address Validation?',
                }
            },
            {
                name: 'hasEmailVerification',
                type: 'yesnoradio',
                required: true,
                props: {
                  labelKey: 'Require Email Verification? (modal with confirmation code)',
                }
            },  
            {
              conditionalSection: true,
              name: 'hasMinimumAge',
              required: true,
              props: {
                labelKey: 'editbreak.steps.lead_gen.rules.has_minimum_age'
              },
              fields: [
                {
                  type: 'number',
                  name: 'minimumAge',
                  required: true,
                  props: {
                    labelKey: 'editbreak.steps.lead_gen.rules.minimum_age',
                    min: 13,
                    max: 120
                  }
                }
              ]
            }, // end has minimum age
            // {
            //     conditionalSection: true,
            //     name: 'hasSubmissionLimit',
            //     required: false,
            //     props: {
            //       labelKey: 'Maximum Total Submission (per break)?',
            //       helpContent: 'Setting this to Yes will prevent users from seeing the form once a threshold has been met.',
            //     },
            //     fields: [
                  {
                    type: 'number',
                    name: 'submissionLimit',
                    required: false,
                    props: {
                      labelKey: 'Maximum Total Submissions (per break)',
                    }
                  },
                  {
                    type: "contenteditable",
                    name: "submissionLimitReachedHeadline",
                    required: false,
                    // Headline is only allowed if there is more than one step
                    showField: (proxy) => ( Number.isInteger(proxy.currentResource.submissionLimit)),

                    props: {
                      labelKey: "Max Entries Reached - Headline",
                    },
                  },
                  {
                      type: "contenteditable",
                      name: "submissionLimitReachedCopy",
                      required: false,
                      showField: (proxy) => ( Number.isInteger(proxy.currentResource.submissionLimit)),

                      props: {
                        labelKey: "Max Entries Reached - Copy",
                      },
                  },  
            //     ]
            //   },
              {
                // not currently implemented. 
                // needs to be more rich. like 1 per day, 1 per campaign
              conditionalSection: true,
              name: 'hasMaxEntries',
              required: false,
              disabled: true,
              props: {
                labelKey: 'Maximum Prize Entries (per person)? (this currently does not work)'
              },
              fields: [
                {
                  type: 'number',
                  name: 'maxPrizeEntries',
                  required: true,
                  disabled: true,
                  props: {
                    labelKey: 'editbreak.steps.lead_gen.rules.max_entries',
                    min: 1,
                    max: 100
                  }
                }
              ]
            },

          ]
        }, // end rules
        {
          subSection: true,
          key: "leadGenThanks",
          sectionWrapper: IndexedSubSectionWrapper,
          props: {
            'headerKey': 'editbreak.steps.lead_gen.thanks.header'
          },
          fields: [
            {
              conditionalSection: true,
              name: 'showThanksPage',
              required: true,
              props: {
                labelKey: 'editbreak.steps.lead_gen.thanks.show_thanks'
              },
              fields: [
                {
                  name: 'thanksHeadline',
                  type: 'contenteditable',
                  required: true,
                  props: {
                    labelKey: 'editbreak.steps.lead_gen.thanks.headline'
                  }
                },
                {
                  name: 'thanksImageId',
                  type: 'image',
                  required: true,
                  idFor: 'thanksImage',
                  props: {
                    labelKey: 'editbreak.steps.lead_gen.thanks.image',
                    imageType: 'leadGen'
                  }
                },
                {
                  name: 'thanksDesc',
                  type: 'contenteditable',
                  required: true,
                  props: {
                    labelKey: 'editbreak.steps.lead_gen.thanks.desc'
                  }
                }
              ]
            } // end show thanks page
          ]
        },
        {
            type: 'currentId',
            name: 'lgid',
            label: 'LeadGen ID',
        },
    
    ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/steps/lead-gen.js